/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @author Alexander Golshtein
 * @version 1.25.0
 * @since 1.14.0
 */

import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import ModalErrorCommon from '../components/ModalError';
import { modalOpen } from '../modalActions';
import { IModalRenderProps } from '../types/modalTypes';

export const useModalOpenError = () => {

    const dispatch = useDispatch();

    const { modal } = useSelector(makeSelectTranslationCommon());

    const open = useCallback((text?: string, title?: string) => {
        dispatch(modalOpen({
            render: (props: IModalRenderProps) => <ModalErrorCommon
                title={title}
                translation={modal}
                onCloseModal={props.onCloseModal}
            >
                {text}
            </ModalErrorCommon>,
        }));
    }, [dispatch, modal]);

    return { open };
};
